var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "phone-icon",
    d: "M15.226 19.932c-2.614-.802-4.92-2.206-6.936-4.223s-3.42-4.323-4.222-6.936a1.54 1.54 0 01.383-1.541l1.929-1.93a1.032 1.032 0 011.46 0L8.896 6.36c.498.64.448 1.639.07 2.356-1.083 2.059-.824 3.905.778 5.54 1.605 1.637 3.45 1.9 5.534.787.72-.384 1.722-.435 2.366.066l.96.96a1.039 1.039 0 01.091 1.552l-1.928 1.929a1.54 1.54 0 01-1.541.383z"
  })));
}
export default SvgPhone;